/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import * as base from './base';
import * as skill from './namespaces/skill';

export { base, skill };
export * from './base';
export * from './namespaces/skill';

export type Int64 = string | number;

export default class AgentSkillService<T> {
  private request: any = () => {
    throw new Error('AgentSkillService.request is undefined');
  };
  private baseURL: string | ((path: string) => string) = '';

  constructor(options?: {
    baseURL?: string | ((path: string) => string);
    request?<R>(
      params: {
        url: string;
        method: 'GET' | 'DELETE' | 'POST' | 'PUT' | 'PATCH';
        data?: any;
        params?: any;
        headers?: any;
      },
      options?: T,
    ): Promise<R>;
  }) {
    this.request = options?.request || this.request;
    this.baseURL = options?.baseURL || '';
  }

  private genBaseURL(path: string) {
    return typeof this.baseURL === 'string'
      ? this.baseURL + path
      : this.baseURL(path);
  }

  ListSkills(
    req: skill.ListSkillsRequest,
    options?: T,
  ): Promise<skill.ListSkillsResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/list');
    const method = 'POST';
    const data = {
      space_id: _req['space_id'],
      page: _req['page'],
      keyword: _req['keyword'],
      statuses: _req['statuses'],
      capabilities: _req['capabilities'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  GetSkill(
    req: skill.GetSkillRequest,
    options?: T,
  ): Promise<skill.GetSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/get');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      space_id: _req['space_id'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  CreateSkill(
    req: skill.CreateSkillRequest,
    options?: T,
  ): Promise<skill.CreateSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/create');
    const method = 'POST';
    const data = {
      space_id: _req['space_id'],
      name: _req['name'],
      description: _req['description'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  UpdateSkill(
    req: skill.UpdateSkillRequest,
    options?: T,
  ): Promise<skill.UpdateSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/update');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      name: _req['name'],
      description: _req['description'],
      network_access: _req['network_access'],
      env_requirements: _req['env_requirements'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  ListSkillCredentials(
    req: skill.ListSkillCredentialsRequest,
    options?: T,
  ): Promise<skill.ListSkillCredentialsResponse> {
    return this.request(
      {
        url: this.genBaseURL('/api/agent_skill/credential/list'),
        method: 'POST',
        data: { skill_id: req.skill_id, Base: req.Base },
      },
      options,
    );
  }

  ConfigureSkillCredential(
    req: skill.ConfigureSkillCredentialRequest,
    options?: T,
  ): Promise<skill.ConfigureSkillCredentialResponse> {
    return this.request(
      {
        url: this.genBaseURL('/api/agent_skill/credential/configure'),
        method: 'POST',
        data: {
          skill_id: req.skill_id,
          env_name: req.env_name,
          value: req.value,
          Base: req.Base,
        },
      },
      options,
    );
  }

  RotateSkillCredential(
    req: skill.RotateSkillCredentialRequest,
    options?: T,
  ): Promise<skill.RotateSkillCredentialResponse> {
    return this.request(
      {
        url: this.genBaseURL('/api/agent_skill/credential/rotate'),
        method: 'POST',
        data: {
          credential_id: req.credential_id,
          expected_revision: req.expected_revision,
          value: req.value,
          Base: req.Base,
        },
      },
      options,
    );
  }

  RevokeSkillCredential(
    req: skill.RevokeSkillCredentialRequest,
    options?: T,
  ): Promise<skill.RevokeSkillCredentialResponse> {
    return this.request(
      {
        url: this.genBaseURL('/api/agent_skill/credential/revoke'),
        method: 'POST',
        data: {
          credential_id: req.credential_id,
          expected_revision: req.expected_revision,
          Base: req.Base,
        },
      },
      options,
    );
  }

  ListSkillFiles(
    req: skill.ListSkillFilesRequest,
    options?: T,
  ): Promise<skill.ListSkillFilesResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/file/list');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      version_id: _req['version_id'],
      page: _req['page'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  GetSkillFileContent(
    req: skill.GetSkillFileContentRequest,
    options?: T,
  ): Promise<skill.GetSkillFileContentResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/file/get');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      path: _req['path'],
      version_id: _req['version_id'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  PutSkillFileContent(
    req: skill.PutSkillFileContentRequest,
    options?: T,
  ): Promise<skill.PutSkillFileContentResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/file/put');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      path: _req['path'],
      expected_revision: _req['expected_revision'],
      content_source: _req['content_source'],
      content: _req['content'],
      content_encoding: _req['content_encoding'],
      object_key: _req['object_key'],
      is_binary: _req['is_binary'],
      mime_type: _req['mime_type'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  DeleteSkillFile(
    req: skill.DeleteSkillFileRequest,
    options?: T,
  ): Promise<skill.DeleteSkillFileResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/file/delete');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      path: _req['path'],
      expected_revision: _req['expected_revision'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  ImportSkillGitHub(
    req: skill.ImportSkillGitHubRequest,
    options?: T,
  ): Promise<skill.ImportSkillResponse> {
    const url = this.genBaseURL('/api/agent_skill/import_github');
    const method = 'POST';
    const data = {
      space_id: req.space_id,
      github_url: req.github_url,
      Base: req.Base,
    };
    return this.request({ url, method, data }, options);
  }

  ImportSkill(
    req: skill.ImportSkillRequest,
    options?: T,
  ): Promise<skill.ImportSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/import');
    const method = 'POST';
    const data = {
      space_id: _req['space_id'],
      object_key: _req['object_key'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  ValidateSkill(
    req: skill.ValidateSkillRequest,
    options?: T,
  ): Promise<skill.ValidateSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/validate');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  ScanSkillRuntime(
    req: skill.ScanSkillRuntimeRequest,
    options?: T,
  ): Promise<skill.ScanSkillRuntimeResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/runtime/scan');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  GetSkillRuntime(
    req: skill.GetSkillRuntimeRequest,
    options?: T,
  ): Promise<skill.GetSkillRuntimeResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/runtime/get');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      version_id: _req['version_id'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  UpdateSkillRuntimeDraft(
    req: skill.UpdateSkillRuntimeDraftRequest,
    options?: T,
  ): Promise<skill.UpdateSkillRuntimeDraftResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/runtime/update');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      base_profile: _req['base_profile'],
      python_requires: _req['python_requires'],
      direct_dependencies: _req['direct_dependencies'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  PublishSkill(
    req: skill.PublishSkillRequest,
    options?: T,
  ): Promise<skill.PublishSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/publish');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      version: _req['version'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  ArchiveSkill(
    req: skill.ArchiveSkillRequest,
    options?: T,
  ): Promise<skill.ArchiveSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/archive');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  DeleteSkill(
    req: skill.DeleteSkillRequest,
    options?: T,
  ): Promise<skill.DeleteSkillResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/delete');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      expected_revision: _req['expected_revision'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  ListSkillVersions(
    req: skill.ListSkillVersionsRequest,
    options?: T,
  ): Promise<skill.ListSkillVersionsResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/version/list');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      page: _req['page'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  DiffSkillVersions(
    req: skill.DiffSkillVersionsRequest,
    options?: T,
  ): Promise<skill.DiffSkillVersionsResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/version/diff');
    const method = 'POST';
    const data = {
      skill_id: _req['skill_id'],
      base_version_id: _req['base_version_id'],
      compare_version_id: _req['compare_version_id'],
      page: _req['page'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  GetBotSelectedSkills(
    req: skill.GetBotSelectedSkillsRequest,
    options?: T,
  ): Promise<skill.GetBotSelectedSkillsResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/bot/get');
    const method = 'POST';
    const data = {
      bot_id: _req['bot_id'],
      space_id: _req['space_id'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }

  UpdateBotSelectedSkills(
    req: skill.UpdateBotSelectedSkillsRequest,
    options?: T,
  ): Promise<skill.UpdateBotSelectedSkillsResponse> {
    const _req = req;
    const url = this.genBaseURL('/api/agent_skill/bot/update');
    const method = 'POST';
    const data = {
      bot_id: _req['bot_id'],
      expected_revision: _req['expected_revision'],
      selected_skills: _req['selected_skills'],
      space_id: _req['space_id'],
      Base: _req['Base'],
    };
    return this.request({ url, method, data }, options);
  }
}
/* eslint-enable */
